<template>
  <div class="console-box flex-column">
    <Header1></Header1>
    <div class="console-box-header">
      <div @click="changeType('user')" :class="type === 'user' ? 'active' : ''">
        个人资料管理
      </div>
      <div
        v-show="userType == 'user'"
        @click="changeType('adress')"
        :class="type !== 'user' ? 'active' : ''"
      >
        收货地址管理
      </div>
    </div>
    <!-- 个人资料管理 -->
    <div class="console-box-content flex-column" v-if="type === 'user'">
      <div class="console-my-content">
        <el-descriptions
          class="margin-top"
          :title="`我的${userType == 'user' ? '个人' : '企业'}信息`"
          :column="1"
          border
        >
          <template slot="extra">
            <el-button type="primary" @click="openUserDialog">编辑</el-button>
          </template>
          <!-- <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-user"></i>
              id
            </template>
            {{ userInfo.id }}
          </el-descriptions-item> -->
          <!-- <el-descriptions-item> -->
          <!-- <template slot="label">
              <i class="el-icon-user"></i>
              用户名
            </template>
            {{ userInfo.name }}
          </el-descriptions-item> -->
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              姓名
            </template>
            {{ userInfo.nickname }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              手机号
            </template>
            {{ userInfo.phone }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-mobile-phone"></i>
              邮箱
            </template>
            {{ userInfo.mailbox }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-office-building"></i>
              个人信息id
            </template>
            {{ userInfo.id }}
          </el-descriptions-item>

          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-office-building"></i>
              注册日期
            </template>
            {{ userInfo.createDate }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <!-- 收货地址管理 -->
    <div class="console-box-content flex-column" v-else>
      <div class="console-header">
        <div style="font-size: 20px"></div>
        <el-button type="primary" @click="addAddr">新增地址</el-button>
      </div>
      <div class="console-content1">
        <el-card class="box-card" v-for="(item, index) in cards" :key="index">
          <div class="card-item" style="font-size: 18px">
            {{ item.name }} <span>{{ item.phone }}</span>
          </div>
          <div class="card-item">
            所在地区：{{ getAddress(item.areaList) || "- -" }}
          </div>
          <div class="card-item">详细地址： {{ item.address || "- -" }}</div>
          <div class="card-item">
            提交日期：{{ item.createdDate || "- -" }}
          </div>
          <div class="card-item">地址ID: {{ item.id || "- -" }}</div>

          <div class="delete-btn" @click="deleteAdress(item.id)">
            <i class="el-icon-close"></i>
          </div>
          <el-button
            @click="openEditAddrDialog(item)"
            class="edit-btn"
            type="warning"
            size="mini"
            >修改</el-button
          >
        </el-card>
      </div>
      <div class="console-footer flex-row-center">
        <el-pagination
          :page-size="pageSize"
          :current-page="currentPage"
          background
          @current-change="currentChange"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 新增、修改地址弹窗 -->
    <el-dialog
      :title="`${addrDialogType == 'add' ? '新增' : '编辑'}地址`"
      :visible.sync="addrDialog"
      width="500px"
      append-to-body
    >
      <el-form
        ref="addrForm"
        :model="addrForm"
        :rules="addrFormRules"
        label-width="80px"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="addrForm.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="addrForm.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="所在地区" prop="areaList">
          <el-cascader
            size="large"
            ref="cascaderAddr"
            :options="addrOptions"
            :props="addressProps"
            v-model="addrForm.areaList"
            style="width: 380px"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="街道门牌" prop="streetNumber">
          <el-input
            v-model="addrForm.streetNumber"
            placeholder="请输入街道门牌"
          />
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="addrForm.address" placeholder="请输入详细地址" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 添加或修改个人信息对话框 -->
    <el-dialog
      :title="`编辑${userType == 'user' ? '个人' : '企业'}信息`"
      :visible.sync="infoDialog"
      width="500px"
      append-to-body
    >
      <!-- 个人用户表单 -->
      <el-form
        ref="userForm"
        :model="userForm"
        :rules="userFormRules"
        label-width="80px"
        v-if="userType == 'user'"
      >
        <el-form-item label="姓名" prop="nickname">
          <el-input v-model="userForm.nickname" placeholder="请输入姓名" />
        </el-form-item>
        <!-- <el-form-item label="用户名" prop="name">
          <el-input v-model="userForm.name" placeholder="请输入用户名" />
        </el-form-item> -->

        <el-form-item label="身份证" prop="identityid">
          <el-input v-model="userForm.identityid" placeholder="请输入身份证" />
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="userForm.phone" placeholder="请输入手机号" />
        </el-form-item>

        <el-form-item label="邮箱地址" prop="mailbox">
          <el-input v-model="userForm.mailbox" placeholder="请输入邮箱地址" />
        </el-form-item>
      </el-form>
      <!-- 企业用户表单 -->
      <el-form
        ref="enterpriseForm"
        :model="enterpriseForm"
        :rules="enterpriseFormRules"
        label-width="100px"
        v-else
      >
        <el-form-item label="公司名称" prop="nickname">
          <el-input
            v-model="enterpriseForm.enterprisename"
            placeholder="请输入公司名称"
          />
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="enterpriseForm.phone" placeholder="请输入手机号" />
        </el-form-item>

        <el-form-item label="所在地区" prop="area">
          <el-cascader
            size="large"
            ref="cascaderAddr"
            :options="addrOptions"
            :props="addressProps"
            v-model="enterpriseForm.area"
            style="width: 380px"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item label="详细地址" prop="address">
          <el-input
            v-model="enterpriseForm.address"
            placeholder="请输入详细地址"
          />
        </el-form-item>

        <el-form-item label="联系人姓名" prop="contactsname">
          <el-input
            v-model="enterpriseForm.contactsname"
            placeholder="请输入联系人姓名"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editUser">确 定</el-button>
        <el-button @click="infoDialog = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header1 from "@/components/Header1.vue";

import {
  list,
  deleteiptbyid,
  queryaddress,
  editAddr,
  harvestaddress,
  enterprisesave,
  userSave
} from "@/api/console";
import { checkEmail, checkIdentitytionId } from "@/utils/reg";
import options from "@/utils/index.js";
export default {
  components: {
    Header1
  },
  data() {
    return {
      addrDialogType: "add",
      addressProps: {
        value: "name",
        label: "name",
        children: "children"
      },
      addrOptions: options,
      addrFormRules: {
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        address: [
          { required: true, message: "详细地址不能为空", trigger: "blur" }
        ],
        streetNumber: [
          { required: true, message: "街道门牌不能为空", trigger: "blur" }
        ],
        areaList: [
          { required: true, message: "所在地区不能为空", trigger: "change" }
        ],

        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      },
      // 个人用户
      userForm: {},
      userFormRules: {
        nickname: [
          { required: true, message: "姓名不能为空", trigger: "blur" }
        ],
        name: [{ required: true, message: "用户名不能为空", trigger: "blur" }],
        mailbox: [{ validator: checkEmail, required: true, trigger: "blur" }],
        identityid: [
          { validator: checkIdentitytionId, required: true, trigger: "blur" }
        ],
        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      },
      addrDialog: false,
      // 企业用户
      enterpriseForm: {},
      enterpriseFormRules: {
        enterprisename: [
          { required: true, message: "企业名称不能为空", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      },
      infoDialog: false,
      addrForm: {
        areaList: [], // 所在区
        name: "",
        streetNumber: "",
        phone: "",
        address: "" // 具体地址
      },
      type: "user",
      pageSize: 5,
      total: 10,
      currentPage: 1,
      cards: [],
      addressName: [] // 具体地区名称
    };
  },
  methods: {
    getAddress(val) {
      if (val) {
        return val.join("-");
      }
    },

    editUser() {
      // 个人信息保存
      if (this.userType == "user") {
        this.$refs["userForm"].validate(valid => {
          if (valid) {
            var data = {
              id: this.userForm.id,
              identity: this.userForm.identityid,
              mailbox: this.userForm.mailbox,
              nickname: this.userForm.nickname,
              phone: this.userForm.phone
            };
            userSave(data).then(res => {
              if (res.code == 200) {
                this.$store.commit("SET_USER_INFO", this.userForm);
                window.localStorage.setItem(
                  "user",
                  JSON.stringify(this.userForm)
                );
                this.infoDialog = false;
                this.$message.success(res.message);
              }
            });
          }
        });
      } else {
        this.$refs["enterpriseForm"].validate(valid => {
          if (valid) {
            // 企业信息保存
            enterprisesave(this.enterpriseForm).then(res => {
              if (res.code == 200) {
                this.$store.commit("SET_USER_INFO", this.enterpriseForm);
                window.localStorage.setItem(
                  "user",
                  JSON.stringify(this.enterpriseForm)
                );
                this.infoDialog = false;
                this.$message.success(res.message);
              }
            });
          }
        });
      }
    },
    openUserDialog() {
      this.infoDialog = true;
    },
    resetAddrForm() {
      this.addrForm = {
        areaList: [],
        name: "",
        streetNumber: "",
        phone: "",
        address: ""
      };
    },
    addAddr() {
      this.addrDialog = true;
      this.addrDialogType = "add";
      this.resetAddrForm();
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["addrForm"].validate(valid => {
        if (valid) {
          harvestaddress(this.addrForm).then(res => {
            if (res.code == 200) {
              this.$message.success(res.message);
              this.addrDialog = false;
              this.resetAddrForm();
              this.getUserList();
            }
          });
        }
      });
    },
    cancel() {
      this.addrDialog = false;
      this.resetAddrForm();
    },
    // 修改弹窗
    openEditAddrDialog(item) {
      this.addrDialogType = "edit";
      this.addrDialog = true;
      this.addrForm = JSON.parse(JSON.stringify(item));
    },
    deleteAdress(id) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteiptbyid(id).then(res => {
            if (res.code == 200) {
              this.$message.success(res.message);
              this.getUserList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getUserList();
    },
    changeType(type) {
      this.type = type;
    },
    getUserList() {
      let params = {
        size: this.pageSize,
        page: this.currentPage,
      };
      queryaddress(params).then(res => {
        if (res.code == 200) {
          this.cards = res.data.records;
          this.total = parseInt(res.data.total) || 1;
        }
      });
    }
  },
  computed: {
    // 登陆用户类型
    userType() {
      return this.$store.getters.userInfo.enterPriseuuid
        ? "enterprise"
        : "user";
    },
    userInfo() {
      return this.$store.getters.userInfo;
    }
  },
  mounted() {
    this.enterpriseForm = JSON.parse(
      JSON.stringify(this.$store.getters.userInfo)
    );
    this.userForm = JSON.parse(JSON.stringify(this.$store.getters.userInfo));
    this.getUserList();
  }
};
</script>
<style scoped lang="scss">
.console-content,
.console-box-content,
.console-box {
  overflow: hidden;
}
.console-box {
  width: 100%;
  height: 100%;
  padding: 40px 50px;
  padding-bottom: 0;
  .console-box-header {
    height: 45px;
    border-bottom: 2px solid #eee;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #101010;
    margin-bottom: 30px;
    margin-top: 70px;
    div {
      padding: 20px;
      text-align: center;
      cursor: pointer;
    }
    .active {
      color: rgba(58, 98, 215, 100);
    }
  }
  .console-box-content {
    flex: 1;
    padding: 0 50px;
    .console-my-content {
    }
    .console-header {
      position: relative;
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
    }
    .console-content1 {
      overflow-y: auto;
      flex: 1;
      .box-card {
        margin-bottom: 10px;
        position: relative;
        .delete-btn {
          position: absolute;
          top: 20px;
          right: 20px;
          font-size: 20px;
          cursor: pointer;
        }
        .edit-btn {
          position: absolute;
          bottom: 20px;
          right: 20px;
          cursor: pointer;
        }
        .card-item {
          margin-bottom: 15px;
        }
      }
    }
    .console-footer {
      height: 10%;
      max-height: 60px;
    }
  }
}
</style>
